import { Attribute, Module, Unit } from "@apis/index";
import Header from "@commons/header";
import ModuleDropdown from "@commons/modules/dropdown";
import Button from "@components/button";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import ButtonWrapper from "@components/wrapper/button-wrapper";
import { RootState } from "@store/index";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormItem } from "./styles";

const UnitForm = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    moduleId: "",
    values: "",
  });
  const {
    data: units,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.units);
  // Fetch modules
  const fetchModule = async () => {
    await Module.list({ state: "modules", params: { isActive: true } });
  };
  const fetchUnits = async () => {
    await Unit.list({
      state: "units",
    });
  };
  useEffect(() => {
    fetchModule();
    if (state) {
      setInitialValues({
        moduleId: state.module?.id || "",
        values: state.name || "",
      });
    } else {
      setInitialValues({ moduleId: "", values: "" });
    }
  }, [state]);

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const itemsPayload =
        !state?.id &&
        values?.values?.map((val: string) => ({
          name: val,
          moduleId: values.moduleId,
        }));

      const payload =
        !!state || state?.id
          ? {
              moduleId: values.moduleId,
              name: values.values,
            }
          : { items: itemsPayload };

      console.log("Payload to send:", payload);

      if (state?.id) {
        await Unit.update({
          state: "units",
          id: state?.id,
          data: payload,
        }).then(() => {
          navigate(`/admin/product-management/units`);
          fetchUnits();
        });
      } else {
        await Unit.create({ state: "units", data: payload }).then((res) => {
          navigate(
            `/admin/product-management/units?module=${res?.module?.name}`,
          );
          fetchUnits();
        });
      }

      resetForm();
    } catch (err: any) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <>
      <Header title="Attributes Setup" />
      <Wrapper stylewrapper={`border-radius:12px; padding:24px;`}>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form>
              <Column>
                <Row styleRow="display:flex; gap:20px; align-items:flex-start; margin-bottom:20px">
                  <FormItem>
                    <ModuleDropdown styleInput="width:95.6%" />
                  </FormItem>

                  <FormItem>
                    {!!state || state?.id ? (
                      <Fields.Input name="values" label="Value" />
                    ) : (
                      <Fields.TagInput
                        icon={false}
                        name="values"
                        placeholder="Enter values separated by comma (e.g., S,M,L,XL)"
                        label="Values"
                      />
                    )}
                  </FormItem>
                </Row>

                <ButtonWrapper>
                  <Button title="Reset" type="reset" variant="reset" />
                  <Button
                    title={state?.id ? "Update Attribute" : "Save Attribute"}
                    type="submit"
                  />
                </ButtonWrapper>
              </Column>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </>
  );
};

export default UnitForm;
